export default "/50f517735fec46580f19aae3e56e9fe21614ea75/14ed8dc335eec8ccd043173219a4387f.svg";